import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Error404 = () => {
  return (
    <Container className="text-center" style={{ marginTop: '50px' }}>
      <Row>
        <Col>
          <h1 style={{ fontSize: '72px', color: '#ff0000' }}>404</h1>
          <h2 style={{ fontSize: '36px', color: '#333' }}>Page Not Found</h2>
          <p style={{ fontSize: '18px', color: '#666' }}>
            The page you are looking for does not exist.
          </p>
          <a href="/" style={{ fontSize: '18px', color: '#007bff' }}>
            Go back to Home
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default Error404;